export function isVersionAtLeast(version: string | null | undefined, minimum: string): boolean {
  if (!version) return false

  const current = version.split('.').map(Number)
  const target = minimum.split('.').map(Number)
  const length = Math.max(current.length, target.length)

  for (let i = 0; i < length; i += 1) {
    const a = current[i] ?? 0
    const b = target[i] ?? 0
    if (Number.isNaN(a)) return false
    if (a !== b) return a > b
  }

  return true
}
